/**
 * Shared Slug Generation & Cleaning Utilities
 *
 * Rules:
 * - lowercase
 * - trim whitespace
 * - spaces become -
 * - duplicate - become single -
 * - remove unsupported special characters (preserve letters, digits, / and -)
 * - & becomes "and"
 * - preserve numbers
 * - preserve / as a path separator when intentionally used
 * - remove empty path segments and duplicate /
 * - remove leading/trailing - and /
 * - completely remove any route prefixes like /p/c, /c/p, /p, /c or leading/trailing slashes
 */

// Pure slug generation from a name or text
export const generateSlug = (text) => {
    if (!text) return "";
    let raw = text
        .toString()
        .toLowerCase()
        .replace(/&/g, ' and ')
        .split('/')
        .map(segment =>
            segment
                .trim()
                .replace(/[^a-z0-9\s-]/g, '')
                .replace(/[\s-]+/g, '-')
                .replace(/^-+|-+$/g, '')
        )
        .filter(Boolean)
        .join('/');

    if (!raw) return "";
    // Remove any accidental prefix like /p/c/, /c/p/, /p/, /c/, p/c/, etc.
    raw = raw.replace(/^\/?(p\/c|c\/p|p|c)(\/|$)/i, '');
    return raw.replace(/^\/+|\/+$/g, '');
};

// Normalize manual typing in slug input field
export const normalizeSlugInput = (val) => {
    if (!val) return "";
    let cleaned = val
        .toString()
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9/-]/g, '')
        .replace(/-+/g, '-')
        .replace(/\/+/g, '/');

    // Strip leading prefixes like /p/c/, /c/p/, /p/, /c/
    cleaned = cleaned.replace(/^\/?(p\/c|c\/p|p|c)(\/|$)/i, '');
    if (cleaned.startsWith('/')) {
        cleaned = cleaned.replace(/^\/+/, '');
    }
    return cleaned;
};

// Final clean on blur or submit
export const cleanSlugFinal = (val) => {
    if (!val) return "";
    let s = val.toString().toLowerCase().trim();
    // Strip prefixes like /p/c, /c/p, /p, /c or leading/trailing slashes
    s = s.replace(/^\/?(p\/c|c\/p|p|c)(\/|$)/i, '');
    return s
        .split('/')
        .map(segment => segment.replace(/^-+|-+$/g, ''))
        .filter(Boolean)
        .join('/');
};
